export const defaultProps = {
  borderRadius: 10,
};
